<div #viewport class="viewport" onScrollView (viewStateChange)="onViewStateChange($event.isVisible)"
  (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
  <paged-virtual-scroller
    #pvs
    class="flex w-full"
    [horizontal]="true"
    [itemTpl]="itemTpl"
    [itemHeight]="itemHeight"
    [itemWidth]="(itemWidth + colGap)"
    [pageSize]="pageSize"
    [itemsQuery]="itemsQuery"
    [enableVirtualScroll]="enableVirtualScroll"
    [renderOnInVisible]="renderOnInVisible"
    [renderOnTimeOut]="renderOnTimeOut">
  </paged-virtual-scroller>
</div>
